export default __webpack_public_path__ + "static/media/banner_webinar_6agosto.3970f083.jpg";